import { Icon } from '@/general/Icons/Icon';

import { FilterName } from '@/plp/components/FilterName/FilterName';

import { FilterOption, PlpHierarchyFilterItemProps } from '../PlpFilters.type';
import { FilterOptionFieldsGroup } from '../components/Fields/FilterOptionFieldsGroup';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';

type Props = PlpHierarchyFilterItemProps<FilterOption>;

export const FilterTransmission = ({ options, currentFilters, index, showNotificationBadge, ...props }: Props) => {
  const id = 'transmission';
  const header = (
    <FilterName
      icon={<Icon name="manual-transmission" />}
      label="Transmission"
      showNotificationBadge={showNotificationBadge}
    />
  );
  const content = (
    <FilterOptionFieldsGroup
      options={options.map((option) => ({ ...option, label: option.label ?? '' }))}
      currentFilters={currentFilters}
      {...props}
    />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
